export const CONTACT_US_URL = 'https://www.windsor-telecom.co.uk/contact-us/'
export const STATUS_PAGE_URL = 'https://status.windsor-telecom.co.uk'

export default {
    CONTACT_US_URL,
    STATUS_PAGE_URL
}
